import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      category: 'Pedidos y Volumen',
      icon: 'ri-stack-line',
      question: '¿Manejan pedidos en volumen para empresas?',
      answer: 'Sí, estamos especializados en el abastecimiento continuo para empresas, industrias y negocios de todos los tamaños. Ofrecemos precios escalonados según volumen de compra, con condiciones preferenciales para contratos de suministro mensual o trimestral. Contáctanos para recibir una propuesta personalizada según tus necesidades de consumo.'
    },
    {
      category: 'Crédito Empresarial',
      icon: 'ri-bank-card-line',
      question: '¿Ofrecen crédito o financiamiento para clientes corporativos?',
      answer: 'Contamos con líneas de crédito empresarial para clientes con historial de compra establecido. Los plazos van de 15 a 30 días según el perfil del cliente. Para empresas de gobierno, industria manufacturera y sector salud, manejamos condiciones especiales de pago alineadas a sus ciclos de presupuesto. Solicita una evaluación de crédito sin compromiso.'
    },
    {
      category: 'Mezclas Personalizadas',
      icon: 'ri-flask-line',
      question: '¿Desarrollan fórmulas o mezclas químicas a medida?',
      answer: 'Sí, ofrecemos el desarrollo de productos químicos personalizados según los requerimientos específicos de cada proceso industrial. Nuestro equipo técnico analiza las necesidades de tu operación y formula soluciones adaptadas a tus estándares de limpieza, desinfección o mantenimiento. Este servicio está disponible para clientes con contratos de suministro activos.'
    },
    {
      category: 'Tiempos de Entrega',
      icon: 'ri-truck-line',
      question: '¿Cuáles son los tiempos de entrega para pedidos empresariales?',
      answer: 'Para pedidos estándar dentro de Aguascalientes, el tiempo de entrega es de 24 a 48 horas hábiles. Para pedidos programados bajo contrato de suministro, coordinamos rutas de entrega fijas según tu calendario operativo. Pedidos urgentes pueden gestionarse el mismo día sujeto a disponibilidad. Cubrimos toda la región centro del país.'
    },
    {
      category: 'Certificaciones',
      icon: 'ri-shield-check-line',
      question: '¿Sus productos cuentan con certificaciones o registros sanitarios?',
      answer: 'Todos nuestros productos cumplen con las normas oficiales mexicanas (NOM) aplicables. Los químicos de limpieza e higiene cuentan con registros ante COFEPRIS cuando aplica. Para sectores regulados como salud, alimenticio y gobierno, podemos proporcionar fichas técnicas, hojas de seguridad (MSDS) y documentación de cumplimiento normativo.'
    },
    {
      category: 'Contratos de Suministro',
      icon: 'ri-file-text-line',
      question: '¿Ofrecen contratos de suministro continuo?',
      answer: 'Sí, contamos con esquemas de contrato de suministro mensual, trimestral y anual. Estos contratos incluyen: precios fijos durante la vigencia, entregas programadas, inventario reservado, soporte técnico prioritario y un ejecutivo de cuenta dedicado. Ideal para empresas que requieren abastecimiento constante y predecible de insumos de limpieza e higiene.'
    },
    {
      category: 'Sectores Atendidos',
      icon: 'ri-building-line',
      question: '¿A qué sectores empresariales atienden principalmente?',
      answer: 'Nos especializamos en atender: industria manufacturera, sector salud (hospitales, clínicas, laboratorios), hotelería y turismo, industria alimenticia y restaurantes, sector gubernamental y dependencias públicas, oficinas corporativas y centros comerciales. Cada sector recibe una propuesta de productos adaptada a sus normativas y necesidades específicas.'
    },
    {
      category: 'Asesoría Técnica',
      icon: 'ri-customer-service-2-line',
      question: '¿Brindan asesoría técnica para la selección de productos?',
      answer: 'Contamos con un equipo de asesores técnicos especializados que pueden visitar tus instalaciones para evaluar tus necesidades y recomendar los productos más eficientes. Ofrecemos capacitación al personal en el uso correcto de químicos industriales, protocolos de sanitización y mejores prácticas de higiene según el sector. Este servicio es gratuito para clientes con contrato activo.'
    }
  ];

  return (
    <section id="faq" className="py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-semibold tracking-widest text-royal-600 uppercase mb-4">
            Información Empresarial
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-5 leading-tight">
            Preguntas frecuentes<br />
            <span className="text-royal-600">para clientes empresariales</span>
          </h2>
          <div className="w-16 h-0.5 bg-royal-600 mx-auto mb-6"></div>
          <p className="text-gray-500 text-base max-w-2xl mx-auto">
            Resolvemos las dudas más comunes sobre nuestros servicios de suministro industrial, contratos corporativos y soluciones personalizadas.
          </p>
        </div>

        {/* FAQ List */}
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`bg-white rounded-xl border transition-all duration-200 overflow-hidden ${
                openIndex === index ? 'border-royal-200 shadow-md' : 'border-gray-100 hover:border-gray-200 hover:shadow-sm'
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center gap-4 text-left cursor-pointer"
              >
                <div className={`w-9 h-9 flex items-center justify-center rounded-lg flex-shrink-0 transition-colors ${
                  openIndex === index ? 'bg-royal-600 text-white' : 'bg-gray-100 text-gray-500'
                }`}>
                  <i className={`${faq.icon} text-base`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <span className={`text-xs font-semibold uppercase tracking-wide mb-0.5 block ${
                    openIndex === index ? 'text-royal-600' : 'text-gray-400'
                  }`}>{faq.category}</span>
                  <h4 className="text-sm font-semibold text-gray-900 leading-snug">{faq.question}</h4>
                </div>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform ${
                  openIndex === index ? 'rotate-45' : ''
                }`}>
                  <i className={`text-lg ${openIndex === index ? 'ri-add-line text-royal-600' : 'ri-add-line text-gray-400'}`}></i>
                </div>
              </button>

              {openIndex === index && (
                <div className="px-6 pb-6 pl-[4.25rem]">
                  <p className="text-gray-600 text-sm leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-14 bg-gradient-to-r from-navy-800 to-royal-700 rounded-2xl p-10 text-center">
          <div className="w-14 h-14 flex items-center justify-center bg-white/15 rounded-full mx-auto mb-5">
            <i className="ri-question-answer-line text-white text-2xl"></i>
          </div>
          <h3 className="text-2xl font-bold text-white mb-3">¿Tienes preguntas específicas sobre tu empresa?</h3>
          <p className="text-white/75 text-sm mb-8 max-w-xl mx-auto">
            Nuestros asesores corporativos están disponibles para atender requerimientos específicos de tu industria o sector.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="tel:4499171543"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-white text-royal-700 font-semibold rounded-lg hover:bg-gray-50 transition-colors shadow-lg whitespace-nowrap cursor-pointer text-sm"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line text-sm"></i>
              </div>
              449 917 1543
            </a>
            <a
              href="https://wa.me/524492037021?text=Hola%2C%20tengo%20una%20consulta%20sobre%20sus%20servicios%20empresariales."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-whatsapp-line text-sm"></i>
              </div>
              Consultar por WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
